// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"sr_a bhp_rc bhp_qx bhp_xr","ForumPosts__contest":"sr_b bhp_hq","ForumPosts__counselling":"sr_c"};